export default __webpack_public_path__ + "static/media/talk.0332be72.svg";